import React from "react";

const NotFound = () => {
  return <div>TODO 404</div>;
};

export default NotFound;
